export const FT_LOGIN_TRACKING_CONSENT = 'ldt_login_tracking_consent';
